export default __webpack_public_path__ + "static/media/MercedesFavicon.6a899aeb.ico";